import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { PasswordForm } from "../components/Form";
import { UserApi } from "../api-services/user.api";

export function Password()
{
    const user = UserApi();
    
    const [isVisible, setIsVisible] = useState(false);

    const [phone, setPhone] = useState();
    const [status, setStatus] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const handleForm = async (e) => {
        e.preventDefault();
        setIsVisible(false);
        setIsLoading(true);
        try {
            const res = await user.genPasswordToken({phone : phone});
            setIsLoading(false);
            if(res.data.success){
                setStatus(1);
                setIsVisible(true);
            }  
            else{ setStatus(-1); } 
            setPhone('');
        } catch (err) { 
            setStatus(-1);
            setIsLoading(false);
        }
    }

    return (

      <div className="vh-100 d-flex flex-column justify-content-between">
        <div className="container-fluid py-4 bg-green-light border-bottom"></div>
        <div className="container py-5">
          <div className="row d-flex align-items-center justify-content-center py-5 px-2">
            <div className="col-lg-5">

              <form onSubmit={ handleForm } className="d-flex flex-column">
                <div className="d-flex flex-column align-items-center gap-2 mb-4" > 
                  <img src="./favicon.png" alt="icon-agrospace" width="60" className=""/>
                  <span className="fs-4 text-muted"> Agrospace - Mot de passe oublié </span>
                  <span className="text-muted text-center px-4 mb-4">
                    Saisissez votre numéro de téléphone, et nous vous enverrons un code de validation pour réinitialiser rapidement et en toute sécurité votre mot de passe."  
                  </span>
                </div>
                {
                  isLoading && (
                    <div className="d-flex justify-content-center align-items-center mb-3"> 
                       <div className="spinner-border text-success" role="status" aria-label="Chargement"></div>
                    </div>
                  )
                }
                {
                  status === -1 && (
                    <div className="col-md-12 mb-2">
                      <div className="alert alert-danger">
                        Une erreur est survenue durant le traitement. Vérifiez votre numéro puis réessayez.
                      </div>
                    </div>
                  )
                }
                {/* -------------------------------- */}
                <div className="col-md-12 mb-2"> 
                  <div className="d-flex gap-2 mb-2">
                    <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-secondary"> +221 </span> 
                    <input type="number" name="phone" placeholder="Votre numéro de téléphone" className="w-100 border input py-3 px-3 text-muted rounded-2" required onChange={ e => setPhone(e.target.value)  } />
                    <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                  </div>
                </div>
                {/* -------------------------------- */}
                <button type="submit" className="btn btn-lg btn-success px-4 mt-2"> 
                  Soumettre <i className="bi bi-arrow-right"></i> 
                </button> 
                    
              </form>
               
               {
                   isVisible && ( <PasswordForm /> )
               }
              
            </div>
          </div>
        </div>
       
        <div className="container-fluid p-4 bg-green-light">
          {/* Bottom Section */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center pt-3 border-top">
            <p className="mb-2 mb-md-0"> © 2025 Agrospace pack. Tout droit réservé. </p>
            <div className="d-flex flex-wrap gap-3">
              <p className="mb-2 mb-md-0"> powered by Xelkoom-AI </p>
            </div>
          </div>
          {/* Social Icons */}
          <div className="d-flex justify-content-center gap-3 my-3">
              <i className="bi bi-facebook fs-5"></i>
              <i className="bi bi-twitter-x fs-5"></i>
              <i className="bi bi-linkedin fs-5"></i>
              <i className="bi bi-github fs-5"></i>
              <i className="bi bi-instagram fs-5"></i>
              <i className="bi bi-youtube fs-5"></i>
          </div>
        </div>

      </div>
    )
}